function fmtNum(n) {
  if (n == null) return '0';
  if (Number.isNaN(Number(n))) return String(n);
  const num = Number(n);

  if (num < 1000) return String(num);

  return new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(num);
}

export default fmtNum;
